export const load = () => ({
	title: 'Expedited Production',
	showTitle: false,
	noindex: false,
});
